import type { PublicPage } from "./content-types.ts"
import { CONTENT_STATES } from "./content-types.ts"

const record = (page: Omit<PublicPage, "states" | "updatedAt" | "version">): PublicPage => ({ ...page, states: CONTENT_STATES, updatedAt: "2026-07-26", version: "1.0" })

export const STATIC_PUBLIC_PAGES = [
  record({
    id: "WEB-HOME-001",
    path: "/",
    slug: "home",
    kind: "home",
    eyebrow: "CashHub 통합잔액",
    title: "흩어진 리워드를 한곳에서 더 분명하게",
    summary: "여러 제휴 리워드가 하나의 통합잔액으로 모이는 과정을 쉽고 안전하게 안내합니다.",
    sections: [
      { title: "제휴 서비스에서 시작", body: "이용 중인 제휴 서비스에서 전환을 요청하면 CashHub가 안전한 확인 절차를 이어갑니다." },
      { title: "조건을 먼저 확인", body: "보내는 원천 포인트와 최종 적립될 통합잔액을 동의 전에 한눈에 보여드립니다." },
      { title: "통합잔액으로 혜택 이용", body: "확인된 통합잔액은 승인된 제휴 상품을 교환하는 데 사용할 수 있습니다." },
    ],
    primaryAction: { href: "/start", label: "CashHub 시작하기" },
    secondaryAction: { href: "/partner", label: "제휴 문의" },
  }),
  record({
    id: "WEB-HOME-002",
    path: "/service",
    slug: "service",
    kind: "content",
    eyebrow: "서비스 소개",
    title: "흩어진 포인트를 한 곳에서, 필요한 혜택으로",
    summary: "포인트 전환부터 통합잔액 확인과 상품 사용까지 필요한 흐름을 쉽게 이어갑니다.",
    sections: [
      { title: "포인트 전환", body: "제휴 서비스에서 시작한 요청을 확인하고 적용 조건을 투명하게 보여드립니다." },
      { title: "통합잔액", body: "사용 가능, 보류, 소멸 예정 금액을 구분해 지금 쓸 수 있는 잔액을 명확히 안내합니다." },
      { title: "상품 교환", body: "승인된 상품만 제공하고 교환 전 금액과 유의사항을 다시 확인합니다." },
    ],
    primaryAction: { href: "/start", label: "서비스 시작" },
  }),
  record({
    id: "WEB-HOME-003",
    path: "/guide",
    slug: "guide",
    kind: "content",
    eyebrow: "이용 방법",
    title: "전환부터 사용까지 간단하게",
    summary: "제휴 서비스에서 전환을 시작한 뒤 조건 확인, 통합잔액 적립, 상품 교환 순서로 이어집니다.",
    sections: [
      { title: "제휴 서비스에서 전환 시작", body: "CashHub 안에서 임의로 포인트를 조회하지 않고, 이용 중인 제휴 서비스에서 시작합니다." },
      { title: "전환 조건 확인", body: "보내는 원천 포인트와 최종 적립될 통합잔액을 확인하고 동의합니다." },
      { title: "통합잔액 확인", body: "처리가 완료되면 사용 가능한 금액과 이용 내역을 확인합니다." },
      { title: "상품 교환", body: "상품 조건과 차감 금액을 확인한 뒤 원하는 혜택으로 교환합니다." },
    ],
    primaryAction: { href: "/faq", label: "자주 묻는 질문" },
  }),
  record({
    id: "WEB-HOME-004",
    path: "/policy",
    slug: "policy",
    kind: "policy",
    eyebrow: "이용 정책",
    title: "전환과 잔액 이용 기준을 한곳에서",
    summary: "전환 조건, 잔액 유효기간, 상품 교환과 복원 기준을 문서별로 확인할 수 있습니다.",
    sections: [
      { title: "전환 기준", body: "전환비율, 적용 단위, 최소·최대 금액은 제공되는 정책 문서에서 확인할 수 있습니다." },
      { title: "잔액과 상품 이용", body: "유효기간, 취소 가능 여부, 오류 발생 시 처리 방법은 각 정책 문서에서 안내합니다." },
    ],
    primaryAction: { href: "/terms/point", label: "통합잔액 정책 확인" },
  }),
  record({ id: "WEB-HOME-005", path: "/partner", slug: "partner", kind: "partner", eyebrow: "제휴 문의", title: "함께 더 나은 리워드 경험을 만듭니다", summary: "대행사, 매체, 상품 공급사를 위한 제휴 문의를 안전하게 접수합니다.", sections: [] }),
  record({ id: "WEB-HOME-006", path: "/notices", slug: "notices", kind: "notices", eyebrow: "공지사항", title: "CashHub 소식", summary: "서비스 이용에 필요한 중요한 안내를 확인하세요.", sections: [] }),
  record({ id: "WEB-HOME-007", path: "/notices/:id", slug: "notice-detail", kind: "notices", eyebrow: "공지사항", title: "공지 상세", summary: "선택한 공지의 내용을 확인합니다.", sections: [] }),
  record({ id: "WEB-HOME-008", path: "/faq", slug: "faq", kind: "faq", eyebrow: "자주 묻는 질문", title: "궁금한 내용을 빠르게 찾아보세요", summary: "가입, 전환, 잔액, 상품 교환에 관한 핵심 답변을 확인하세요.", sections: [], primaryAction: { href: "/support", label: "도움이 더 필요해요" } }),
  record({
    id: "WEB-HOME-009",
    path: "/support",
    slug: "support",
    kind: "content",
    eyebrow: "고객지원",
    title: "궁금한 점을 빠르게 해결해 드려요",
    summary: "자주 묻는 질문을 확인하거나 로그인 후 문의를 남길 수 있습니다.",
    sections: [
      { title: "먼저 FAQ를 확인해 주세요", body: "일반적인 이용 방법과 상태별 안내를 빠르게 찾을 수 있습니다." },
      { title: "계정·거래 문의", body: "본인 확인이 가능한 CashHub 로그인 후 문의 경로를 이용해 주세요." },
      { title: "안전한 문의", body: "쿠폰 번호나 비밀번호 같은 민감한 정보는 문의 내용에 적지 마세요." },
    ],
    primaryAction: { href: "/faq", label: "FAQ 보기" },
    secondaryAction: { href: "/start", label: "로그인 경로 안내" },
  }),
  record({ id: "WEB-HOME-010", path: "/terms/service", slug: "terms-service", kind: "legal", eyebrow: "이용약관", title: "이용약관", summary: "CashHub 서비스 이용조건과 회원·회사의 권리 및 의무를 확인합니다.", sections: [] }),
  record({ id: "WEB-HOME-011", path: "/terms/privacy", slug: "terms-privacy", kind: "legal", eyebrow: "개인정보처리방침", title: "개인정보처리방침", summary: "CashHub가 처리하는 개인정보, 이용 목적, 보유기간과 이용자 권리를 확인합니다.", sections: [] }),
  record({ id: "WEB-HOME-012", path: "/terms/point", slug: "terms-point", kind: "legal", eyebrow: "통합잔액 정책", title: "전환·통합잔액 운영정책", summary: "현재 문서 본문을 제공하지 않습니다. 잔액 관련 문의는 고객지원에서 확인해 주세요.", sections: [] }),
  record({
    id: "WEB-HOME-013",
    path: "/account-deletion",
    slug: "account-deletion",
    kind: "account",
    eyebrow: "계정 삭제 안내",
    title: "계정 삭제는 본인 확인 후 안전하게",
    summary: "공개 페이지에서 개인정보를 입력하지 않고, 로그인된 CashHub 경로에서 잔액과 진행 거래를 먼저 확인합니다.",
    sections: [
      { title: "1. CashHub 로그인", body: "앱 또는 사용자 웹에서 본인 계정으로 로그인합니다." },
      { title: "2. 잔액과 진행 거래 확인", body: "남은 잔액이나 처리 중인 거래가 있으면 삭제 요청 전에 안전한 처리 방법을 안내받습니다." },
      { title: "3. 계정 삭제 요청", body: "보존되는 정보와 처리 결과를 확인한 뒤 인증된 화면에서 요청합니다." },
    ],
    primaryAction: { href: "/start?continue=%2Fmy%2Fdelete-account", label: "안전한 삭제 경로로 이동" },
  }),
  record({ id: "WEB-HOME-014", path: "/start", slug: "start", kind: "start", eyebrow: "CashHub 시작하기", title: "전환한 캐시와 이용 내역을 확인하세요", summary: "Google 계정으로 간편하게 로그인하고 CashHub를 시작할 수 있습니다.", sections: [] }),
] as const satisfies readonly PublicPage[]
